import { FC, memo } from 'react'
import { Divider } from '@cargomart/ui'
import { useGetCargoSizeQuery } from 'api/cargoSize'
import cn from 'classnames'
import { formatPrice } from 'helpers/common'
import { OrderItem } from 'schema'

import OrderYarcheCreateSummaryCargo from '../OrderYarcheCreateSummaryCargo'
import OrderYarcheCreateSummaryDeliveryDate from '../OrderYarcheCreateSummaryDeliveryDate'

interface OrderYarcheDetailSummaryProps {
  order: OrderItem
  className?: string
  titleClassName?: string
}

const OrderYarcheDetailSummary: FC<OrderYarcheDetailSummaryProps> = (props) => {
  const { className, order, titleClassName = 'text-headline-sm' } = props
  const { size } = order.cargoInfo
  const cargo = size
    ? {
        ...size,
        price: String(size.price)
      }
    : undefined

  const { isLoading } = useGetCargoSizeQuery()
  const isPayed = [OrderItem.paymentStatus.FULL, OrderItem.paymentStatus.OVER].includes(order.paymentStatus)

  return (
    <div className={className}>
      <div className={titleClassName}>Отправление</div>
      <div className="py-6">
        <OrderYarcheCreateSummaryCargo cargo={cargo} isLoading={isLoading} />
        <OrderYarcheCreateSummaryDeliveryDate
          isLoading={false}
          deliveryDate={{
            destinationTerminalDate: order.destination.destinationDate || '',
            destinationCourierDate: ''
          }}
        />
        <Divider className="my-2" />

        <div className="flex gap-2 text-title-md">
          <div className={cn({ 'text-positive': isPayed })}>{isPayed ? 'Оплачено' : 'Стоимость'}</div>
          <div className="ml-auto truncate">{order.totalPrice ? `${formatPrice(order.totalPrice, true)}  ₽` : '—'}</div>
        </div>
      </div>
    </div>
  )
}

export default memo(OrderYarcheDetailSummary)
